<template>
<face-failure-content v-bind="$attrs"
  @approve="approve"
  @reject="reject"
  approveText="Yes"
  rejectText="No"
  :faceLogId="faceLogId"
  :approveDisabled="!decisionAllowed"
  :rejectDisabled="!decisionAllowed"
  >
  <template #employeeQuestion>
    <span class="question">
      Is this
      <template v-if="employeeAvatar">
        <span
          class="avatar-link"
          @click="togglePopover($event)"
          key="employee-name"
        >
          {{ employeeName }}
        </span>
        <PVPopover ref="popover">
          <div class="tw:p-1">
            <avatar :url="employeeAvatar" size="100px" />
          </div>
        </PVPopover>
      </template>
      <template v-else>
        <span key="employee-name">{{ employeeName }}</span>
      </template>
      ?
    </span>
  </template>
</face-failure-content>
</template>
<script>
import Avatar from '@/components/Avatar.vue'
import FaceFailureContent from './FaceFailureContent.vue'
import PVPopover from 'primevue/popover'
import { mapGetters, mapState } from 'vuex'

export default {
  inheritAttrs: false,
  components: {
    Avatar,
    FaceFailureContent,
    PVPopover
  },
  props: {
    faceLogId: Number,
    employee: Number,
    employeeFirstName: String,
    employeeMiddleName: String,
    employeeLastName: String,
    employeeDisplayName: String,
    employeeAvatar: String
  },
  emits: ['approve', 'reject'],
  computed: {
    ...mapState(['orgUserId']),
    ...mapGetters(['canEditSelf']),
    ...mapGetters('formatPreferences', ['formatName']),
    employeeName () {
      return this.formatName(this.employeeFirstName, this.employeeLastName, this.employeeMiddleName, this.employeeDisplayName)
    },
    decisionAllowed () {
      return this.canEditSelf || this.orgUserId !== this.employee
    }
  },
  methods: {
    togglePopover (event) {
      this.$refs.popover.toggle(event)
    },
    approve () {
      this.$emit('approve', {
        id: this.employee,
        name: this.employeeName
      })
    },
    reject () {
      this.$emit('reject')
    }
  }
}
</script>
<style scoped>
.question {
  text-align: left;
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  flex-wrap: wrap;
}

.avatar-link {
  cursor: pointer;
  color: var(--color-indigo-500);
  text-decoration: underline;
  text-decoration-style: dotted;
  -webkit-text-decoration-style: wavy; /* dotted doesn't work in safari */
  transition: color 0.2s;
}

.avatar-link:hover {
  color: var(--color-indigo-400);
}
</style>

